module.exports = __webpack_public_path__ + "static/media/Background.fdb1700a.jpg";